/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive} from '@angular/core';
import {CdkStepper, CdkStepperNext, CdkStepperPrevious} from '@angular/cdk/stepper';
import {MdStepper} from './stepper';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MdStepperNext = CdkStepperNext;
export const /** @type {?} */ _MdStepperPrevious = CdkStepperPrevious;
/**
 * Button that moves to the next step in a stepper workflow.
 */
export class MdStepperNext extends _MdStepperNext { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'button[mdStepperNext], button[matStepperNext]',
  host: {'(click)': '_stepper.next()'},
  providers: [{provide: CdkStepper, useExisting: MdStepper}]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdStepperNext_tsickle_Closure_declarations() {
/** @type {?} */
MdStepperNext.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdStepperNext.ctorParameters;
}

/**
 * Button that moves to the previous step in a stepper workflow.
 */
export class MdStepperPrevious extends _MdStepperPrevious { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'button[mdStepperPrevious], button[matStepperPrevious]',
  host: {'(click)': '_stepper.previous()'},
  providers: [{provide: CdkStepper, useExisting: MdStepper}]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdStepperPrevious_tsickle_Closure_declarations() {
/** @type {?} */
MdStepperPrevious.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdStepperPrevious.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
